export function a11yProps(index: number): { id: string, 'aria-controls': string } {
    return {
        id: `entity-details-tab-${index}`,
        'aria-controls': `entity-details-tabpanel-${index}`,
    };
}
